import {useSettingsQuery} from '@settings/modules/common/providers'

export const useJanusSpecificKpisByDefinition = (upmId?: string, definitionId?: number) => {
  return useSettingsQuery('janusSpecificKpisByDefinition', [{upmId, definitionId}], {
    enabled: !!upmId && !!definitionId,
    staleTime: 0,
    retry: false,
    gcTime: 0
  })
}
